<mat-card>
    <mat-card-header>
        <mat-icon style="cursor: pointer" routerLink="/principal/dashboard">arrow_back</mat-icon>
        <h2>Faturas</h2>
    </mat-card-header>
    <mat-card-content>
        <div class="row">
            <div class="col-12">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSourceInvoices" class="mat-elevation-z8" style="width: 100%">
                        <ng-container matColumnDef="MES_REFERENCIA">
                            <th mat-header-cell *matHeaderCellDef>Período</th>
                            <td class="no-break-word" mat-cell *matCellDef="let element">{{element.MES_REFERENCIA.toString().padStart(2, "0") + "/" + element.ANO_REFERENCIA}} </td>
                        </ng-container>
                        <ng-container matColumnDef="DESCRICAO_FATURA">
                            <th mat-header-cell *matHeaderCellDef>Descrição</th>
                            <td class="no-break-word" mat-cell *matCellDef="let element">{{element.DESCRICAO_FATURA}} </td>
                        </ng-container>
                        <ng-container matColumnDef="DATA_EMISSAO">
                            <th mat-header-cell *matHeaderCellDef>Emissão</th>
                            <td class="no-break-word" mat-cell *matCellDef="let element">{{element.DATA_EMISSAO | date:"dd/MM/y"}} </td>
                        </ng-container>
                        <ng-container matColumnDef="DATA_VENCIMENTO">
                            <th mat-header-cell *matHeaderCellDef>Vencimento</th>
                            <td class="no-break-word" mat-cell *matCellDef="let element">{{element.DATA_VENCIMENTO | date:"dd/MM/y"}} </td>
                        </ng-container>
                        <ng-container matColumnDef="VALOR_TOTAL">
                            <th mat-header-cell *matHeaderCellDef>Valor</th>
                            <td class="no-break-word align-right" mat-cell *matCellDef="let element">{{element.VALOR_TOTAL | currency: 'BRL'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="DATA_PAGAMENTO">
                            <th mat-header-cell *matHeaderCellDef class="align-right">Situação</th>
                            <td class="no-break-word align-right" mat-cell *matCellDef="let element"><div class="no-break-word align-right">{{element.DATA_PAGAMENTO ? 'Pago' : '(Pendente)'}}</div> </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr style="cursor: pointer" mat-row (click)="redirect(row.CODIGO_FATURA)" *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
